import queryString from 'query-string';
import { analyticsService } from '@common/analytics';
import {
  paramOrNul, getClientPlatform, matchPaths,
  toCamelCase, getDataFromStorage
} from '../../common/config/utils';
import { getPayAsYouGoUsedProperty } from '../config/util';
import Const, { purchaseFlowTypes } from '../config/const';
import { appRoutes } from '../config/app_routes';

// Chat Related
export const StatusSuccess = 'success';
export const StatusBusy = 'busy';
export const StatusHangUp = 'hangup';
export const StatusNoAnswer = 'no answer';
export const StatusError = 'error';

export const getFlow = ({ additional, payAsYouGo }) => {
  if (additional) return purchaseFlowTypes.balance;
  if (payAsYouGo) return purchaseFlowTypes.payAsYouGo;
  return purchaseFlowTypes.minutes;
};

export const getContinueSessionValue = () => {
  const { chat: { continuedSession }, voipChat } = window.store.getState();
  if (!(continuedSession || voipChat?.continuedSession)) {
    return {};
  }
  return { 'continued session': continuedSession || voipChat?.continuedSession || 0 };
};

export const clearProps = (props) => {
  const clearedProps = {};
  Object.keys(props).forEach((k) => {
    clearedProps[k] = undefined;
  });
  window.dataLayer.push({
    ...clearedProps
  });
};

export const aditionalPurchaseProps = () => {
  const { purchaseDetails: { isPayg, flow } } = window.store.getState();
  let purchaseFlow = flow;
  const matchPaymentSources = matchPaths({ pathname: appRoutes.paymentSources, path: window.location.pathname });
  if (!purchaseFlow && matchPaymentSources) {
    purchaseFlow = purchaseFlowTypes.paymentMethods;
  }
  const props = {
    ...getPayAsYouGoUsedProperty({ flow: purchaseFlow, isPayg }),
    flow: purchaseFlow
  };
  return props;
};

export const getDestination = ({ spendingLimits }) => {
  const destination = !!spendingLimits && !!spendingLimits.length ? { destination: 'jumio' } : null;
  return destination;
};

export const getSessionType = (chatType) => {
  let sessionType = '';
  switch (chatType) {
    case Const.chatType.text:
      sessionType = 'chat';
      break;
    case Const.chatType.voice:
      sessionType = 'voice';
      break;
    case Const.chatType.video:
      sessionType = 'vc';
      break;
    default:
      break;
  }
  return sessionType;
};

export const startChatProperties = (chat, sessionType, analytics) => {
  const {
    advisorId, orderId, name, continuedSession, startChatClickSource, homepageSection, isPayg, flow
  } = chat;
  const advisorAnalytics = window.store.getState().advisors[advisorId]?.analytics;
  return {
    ...analytics,
    ...advisorAnalytics,
    ...paramOrNul('advisor id', advisorId),
    ...paramOrNul('advisor name', name),
    ...paramOrNul('session type', sessionType),
    ...paramOrNul('click source', startChatClickSource),
    ...paramOrNul('order id', orderId),
    'continued session': !continuedSession || continuedSession === undefined ? 0 : continuedSession,
    ...paramOrNul('section', homepageSection),
    ...getPayAsYouGoUsedProperty({ flow, isPayg }),
    flow,
    ...paramOrNul('urgency sentence string', getDataFromStorage('advisor_urgency_signal_text'))
  };
};

export const trackPaygRelatedProps = (payAsYouGo, propValue) => (payAsYouGo ? undefined : propValue);

export const getSessionEventsProps = (chatType, status, chatData, user, analyticsData) => {
  const {
    numberOfChatOrders, numberOfVcOrders, numberOfVoiceCallOrders, analytics
  } = user;
  const {
    initialDuration, initialCharged, initialVoipCharged, initialVoipDuration, isPayg
  } = chatData;

  const { utmCampaign, utmSource } = toCamelCase(queryString.parse(window.location.search));
  const lastHit = getDataFromStorage('LAST_HIT');
  const lastHitSec = (new Date() - new Date(lastHit)) / 1000;
  const sessionCount = parseInt(getDataFromStorage('BROWSER_SESSIONS'), 10) || 0;

  const chatProps = {
    ...startChatProperties(chatData, getSessionType(chatType), analyticsData),
    ...paramOrNul('number of chat orders', numberOfChatOrders),
    ...paramOrNul('number of voice orders', numberOfVoiceCallOrders),
    ...paramOrNul('number of vc orders', numberOfVcOrders),
    ...analytics
  };

  const mpProps = {
    ...paramOrNul(`${ getSessionType(chatType) } initial minutes`, trackPaygRelatedProps(isPayg, (initialDuration || initialVoipDuration) / 60)),
    ...paramOrNul(`${ getSessionType(chatType) } initial credit`, trackPaygRelatedProps(isPayg, initialCharged || initialVoipCharged)),
    ...paramOrNul([`${ getSessionType(chatType) } status`], status),
    ...paramOrNul('session initial minutes', trackPaygRelatedProps(isPayg, (initialDuration || initialVoipDuration) / 60)),
    ...paramOrNul('session initial credit', trackPaygRelatedProps(isPayg, initialCharged || initialVoipCharged)),
    ...paramOrNul('session status', status),
    platform: getClientPlatform()
  };

  const gtmProps = {
    ...paramOrNul('utmCampaign', utmCampaign),
    ...paramOrNul('utmSource', utmSource),
    sessionsCount: sessionCount,
    timeFromLastSession: parseInt(lastHitSec, 10)
  };

  return { ...chatProps, ...mpProps, ...gtmProps  };
};

export const parseAndTrackAnalyticEvents = (analyticEvents, extraProps) => {
  if (!analyticEvents) return;
  const convertedAnalyticEvents = analyticEvents;
  Object.keys(convertedAnalyticEvents).forEach((eventName) => {
    const { application: { analytics } } = window.store.getState();
    const eventProps = analytics?.eventProps?.[eventName] || {};

    analyticsService.trackEvent(eventName, {
      ...convertedAnalyticEvents[eventName],
      ...extraProps,
      ...eventProps
    });
  });
};
